import AgentActivity from 'models/agent_activity';
import ClearAnswerSearchResult from 'actions/customer/clear_answer_search_result';
import ClearCompositionStore from 'actions/knowledge_base/clear_composition_store';
import ClearSnippetErrors from 'actions/knowledge_base/clear_snippet_errors';
import ClearSnippetRevisionsStore from 'actions/knowledge_base/clear_snippet_revisions_store';
import FetchSnippetRevisions from 'actions/knowledge_base/fetch_snippet_revisions';
import KbAdmin from 'models/location/kb_admin';
import OpenKbAdmin from 'actions/knowledge_base/open_kb_admin';
import { registerUrlConverter } from './location_url';
import SearchAnswers from 'actions/knowledge_base/search_answers';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import SnippetEditor from 'models/location/snippet_editor';
import SwitchSnippet from 'actions/knowledge_base/switch_snippet';
import SwitchSnippetNew from 'actions/knowledge_base/switch_snippet_new';

registerUrlConverter(KbAdmin, {
  getPath: () => '/kb-admin',
  getQueryParams: location => {
    let params = {};
    if (location.query) {
      params.q = location.query;
    }
    if (location.language) {
      params.lng = location.language;
    }
    if (location.channel) {
      params.channel = location.channel;
    }
    return params;
  },
});
registerUrlConverter(SnippetEditor, { getPath: se => `/kb-admin/answer/${se.snippetId || 'new'}` });

export default function(router, { runnerContext }) {
  return {
    '/?$': {
      on: () => {
        let queryParams = router.parseQueryParameters().toJS();
        let attr = {};
        if (queryParams.q) {
          attr.query = queryParams.q;
        }
        if (queryParams.lng) {
          attr.language = queryParams.lng;
        }
        if (queryParams.channel) {
          attr.channel = queryParams.channel;
        }

        let searchPagination = {
          from: 0,
          size: 100,
        };
        let snippetSearchResult = runnerContext.stores.snippetSearchResult.get();
        if (snippetSearchResult && snippetSearchResult.query) {
          searchPagination = {
            from: snippetSearchResult.query.from,
            size: snippetSearchResult.query.size,
          };
        }

        runnerContext.executeAction(OpenKbAdmin, attr);
        runnerContext.executeAction(SearchAnswers, {
          searchText: attr.query,
          language: attr.language,
          channel: attr.channel,
          ...searchPagination,
        });
      },
      after: () => {
        runnerContext.executeAction(ClearCompositionStore);
        runnerContext.executeAction(ClearSnippetErrors);
        runnerContext.executeAction(ClearSnippetRevisionsStore);
        runnerContext.executeAction(ClearAnswerSearchResult);
      },
    },
    '/answer/new': {
      on: answerId => {
        runnerContext.executeAction(SwitchSnippetNew);
        runnerContext.executeAction(SetAndLogActivity, { type: AgentActivity.Type.KNOWLEDGE_BASE });
      },
      after: () => {
        runnerContext.executeAction(ClearCompositionStore);
        runnerContext.executeAction(ClearSnippetErrors);
      },
    },
    '/answer/:answerId': {
      on: answerId => {
        runnerContext.executeAction(SwitchSnippet, answerId);
        runnerContext.executeAction(SetAndLogActivity, { type: AgentActivity.Type.KNOWLEDGE_BASE });
        runnerContext.executeAction(FetchSnippetRevisions, answerId);
      },
      after: () => {
        runnerContext.executeAction(ClearCompositionStore);
        runnerContext.executeAction(ClearSnippetErrors);
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/kb_admin_routes.js